export default __webpack_public_path__ + "static/media/edge-unlobed.013c07e7.PNG";